import {
    blankEmptyFormatPercentage,
    formatOneDecimalPercentageWithMultiplier,
    formatVolume,
    getCompactDollars,
    maxThreeDecimals
} from "../../../agent-production/helpers/dataFormatters";
import { terms as mdt } from "..";
import { cardFields } from ".";

export const cardSettings = {
    gridClass: 'grid-2',
    cards: [
        {
            formatter: formatVolume,
            keyField: cardFields.forSaleMedianVolume,
            title: mdt.activeForSale,
            chartFormatter: getCompactDollars,
        },
        {
            formatter: formatVolume,
            keyField: cardFields.soldMedianVolume,
            title: mdt.medianPriceSold,
            chartFormatter: getCompactDollars,
        },
        {
            formatter: formatOneDecimalPercentageWithMultiplier,
            keyField: cardFields.spOpRatioAllProperties,
            title: mdt.salesPriceOriginalPrice,
            chartDataFormatter: maxThreeDecimals,
            changeFormatter: blankEmptyFormatPercentage,
        },
        {
            formatter: formatVolume,
            keyField: cardFields.soldAvgPricePerSqft,
            title: mdt.avgPriceSqft,
            labelUnitType: mdt.avgPricePerSqft,
            chartFormatter: getCompactDollars,
            chartUnitType: '',
        },
    ],
};
